<template>
  <div class="media-caption" :class="`media-caption--${variant}`">
    <div class="media-caption__content" :class="`media-caption__content--${variant}`">
      <div
        v-if="isTypeVideo(medium.type)"
        class="media-caption__play-button"
        @click="$emit('playclick', medium)"
      >
        <i class="media-caption__play-button--default icon-play_default" />
        <i class="media-caption__play-button--hover icon-play_hover" />
      </div>
      <h3
        v-if="medium.title"
        class="media-caption__title media-caption__text"
        :class="[`media-caption__title--${variant}`, `media-caption__text--${variant}`]"
      >
        {{ medium.title }}
      </h3>
      <p
        v-if="medium.description"
        class="media-caption__description media-caption__text"
        :class="[`media-caption__description--${variant}`, `media-caption__text--${variant}`]"
      >
        {{ medium.description }}
      </p>
    </div>
  </div>
</template>

<script>
import { isTypeVideo } from './media-types'

export const VARIANTS = {
  default: 'default',
  centered: 'centered',
}

export default {
  name: 'MediaCaption',
  props: {
    medium: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: VARIANTS.default,
      validator(value) {
        return Object.values(VARIANTS).includes(value)
      },
    },
  },

  methods: {
    isTypeVideo(type) {
      return isTypeVideo(type)
    },
  },
}
</script>

<style lang="scss" scoped>
$play-button-dimension-desktop: 80px;
$play-button-dimension-mobile: 50px;
$spacing-desktop: 32px;
$spacing-mobile: 15px;

.media-caption {
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  background: $color-black;
  background: linear-gradient(0deg, #000 -100%, transparent 100%);

  &--centered {
    top: 0;
    display: block;
    background: none;
  }

  @media ($mq-large) {
    display: block;
  }

  &__content {
    max-width: 666px;
    padding: 50px 40px;
    text-align: left;

    &--centered {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      text-align: center;
    }
  }

  &__play-button {
    position: relative;
    display: inline-block;
    width: $play-button-dimension-mobile;
    height: $play-button-dimension-mobile;
    margin: 0;
    margin-bottom: $spacing-mobile;
    font-size: $play-button-dimension-mobile;
    color: $color-white;

    @media ($mq-large) {
      width: $play-button-dimension-desktop;
      height: $play-button-dimension-desktop;
      margin-bottom: $spacing-desktop;
      font-size: $play-button-dimension-desktop;
    }

    &--default,
    &--hover {
      position: absolute;
      top: 0;
      left: 0;
      @include transition((opacity), $transition-time-fast);
    }

    &--default {
      opacity: 1;
    }

    &--hover {
      opacity: 0;
    }

    &:hover {
      cursor: pointer;
      opacity: 0.75;

      .media-caption__play-button {
        &--default {
          opacity: 0;
        }

        &--hover {
          opacity: 1;
        }
      }
    }
  }

  &__text {
    color: $color-white;
    font-family: $font-family-body;
    font-size: $font-size-small;
    line-height: 1.86;

    @media ($mq-large) {
      font-size: $font-size-normal;
      line-height: 1.75;
    }
  }

  &__title {
    margin: 0;
    margin-bottom: 8px;
    font-weight: bold;
    line-height: 3.36;
    letter-spacing: 0.04em;

    &--centered {
      margin-bottom: $spacing-mobile;
      font-family: $font-family-headings;
      font-size: $font-size-heading-small;
      font-weight: normal;
      line-height: 1.1;
      letter-spacing: 0.005em;

      @media ($mq-large) {
        margin-bottom: $spacing-desktop;
        font-size: $font-size-heading-large;
      }
    }
  }

  &__description {
    letter-spacing: -0.021em;

    &--centered {
      letter-spacing: 0.01875em;
    }
  }
}
</style>
